import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ColorPallet } from "../../utils/colorPallet";
interface IProps {
  totalReturnMedicineQuantity: any;
  uniqueMedicineCount: any;
  totalReturnMedicineAmt: any;
  returnItem: any;
  isPrint?: any;
  discountedAmountSingle?: any;
  discountAmountSingle?: any;
  hasDiscountPercentagePrevious: any;
  discountPerQuantity?: any;
}
const headerData = ["Item(s)", "QTY", "Price", "Amt"];
const ReturnInvoiceTable = ({
  totalReturnMedicineQuantity,
  uniqueMedicineCount,
  totalReturnMedicineAmt,
  returnItem,
  isPrint,
  discountedAmountSingle,
  discountAmountSingle,
  hasDiscountPercentagePrevious,
  discountPerQuantity,
}: IProps) => {
  const [discountAmtPrnt, setDiscountAmtPrnt] = useState<any>(0);
  const [totalDiscountedAmtPrnt, setTotalDiscountedAmtPrnt] = useState<any>(0);

  const totalReturnMedicineQuantityPrint = Array?.isArray(returnItem)
    ? returnItem?.reduce((total, item) => {
        // Ensure item has remainingQuantity and it's a number
        return total + parseFloat(item?.quantity_return || 0);
      }, 0)
    : 0;

  const totalReturnMedicineAmtPrint = Array?.isArray(returnItem)
    ? returnItem?.reduce((total, item) => {
        // Ensure item has remainingQuantity and it's a number
        return total + (item?.sell_price * item?.quantity_return || 0);
      }, 0)
    : 0;

  const filteredHeaderData = hasDiscountPercentagePrevious
    ? [...headerData, "Disc", "Payable Amt"]
    : headerData;

  useEffect(() => {
    // Calculate discounts
    const calculatedDiscounts = returnItem?.map((item: any) => {
      return (
        item?.quantity_to_be_ *
        item?.rate *
        (item?.discountPercSingle / 100)
      );
    });
    setDiscountAmtPrnt(calculatedDiscounts);

    // Calculate discounted amounts
    const calculateDiscountedAmt = returnItem?.map((item: any) => {
      return item?.amount_to_be_return || 0; // Ensure it defaults to 0 if undefined
    });

    // Calculate final amounts after discount
    const finalAmounts = calculateDiscountedAmt?.map(
      (amt: any, index: number) => {
        const discount = calculatedDiscounts[index] || 0; // Use calculatedDiscounts to get the discount value
        return amt - discount; // Subtract discount from the amount
      }
    );

    setTotalDiscountedAmtPrnt(finalAmounts);
  }, [returnItem]);

  return (
    <>
      <Box sx={{ mt: -2 }}></Box>

      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="simple table">
          <TableHead sx={{ backgroundColor: ColorPallet.tableHeaderColor }}>
            <TableRow
              sx={{ borderBottom: `1px solid ${ColorPallet.borderColor}` }}
            >
              {filteredHeaderData?.map((headerItem: any, index: any) => (
                <TableCell
                  key={index}
                  sx={{
                    borderBottom: `1px solid black`,
                    borderTop: `1px solid black`,
                    padding: "6px",
                    height: "24px",
                    fontSize: "24px",
                  }}
                >
                  {headerItem}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {returnItem?.map((row: any, rowIndex: any) =>
              row?.quantity_return || row?.quantity_to_be_ ? ( // Show only if quantity_return exists
                <TableRow key={rowIndex}>
                  {headerData?.map((headerItem: any, colIndex: any) => (
                    <TableCell
                      key={colIndex}
                      sx={{
                        borderBottom: `1px solid black`,
                        fontSize: "24px",
                        padding: "6px",
                        height: "22px",
                      }}
                    >
                      {/* For Item(s) column */}
                      {isPrint
                        ? headerItem === "Item(s)" &&
                          row?.quantity_return !== null && (
                            <>
                              {row?.medicine_name}

                              <span
                                style={{ fontSize: "16px", marginLeft: "3px" }}
                              >
                                {row?.batch?.pharmacy_medicine?.dose}
                              </span>
                            </>
                          )
                        : headerItem === "Item(s)" &&
                          row?.quantity_return !== null && (
                            <>
                              {row?.medicine_name}
                              <span
                                style={{ fontSize: "16px", marginLeft: "3px" }}
                              >
                                {row?.dose}
                              </span>
                            </>
                          )}
                      {/* For QTY column */}
                      {isPrint
                        ? headerItem === "QTY" &&
                          row?.quantity_return !== null &&
                          row?.quantity_return
                        : headerItem === "QTY" &&
                          row?.quantity_return !== null &&
                          row?.quantity_to_be_}
                      {/* For Price column */}
                      {isPrint
                        ? headerItem === "Price" &&
                          row?.quantity_return !== null &&
                          row?.sell_price?.toFixed(2)
                        : headerItem === "Price" &&
                          row?.quantity_return !== null &&
                          row?.rate?.toFixed(2)}

                      {/* For Amount column */}

                      {isPrint
                        ? headerItem === "Amt" &&
                          row?.quantity_return !== null &&
                          (row?.sell_price * row?.quantity_return)?.toFixed(2)
                        : headerItem === "Amt" &&
                          row?.quantity_return !== null &&
                          row?.amount_to_be_return?.toFixed(2)}
                    </TableCell>
                  ))}
                  {hasDiscountPercentagePrevious && (
                    <>
                      <TableCell
                        sx={{
                          borderBottom: `1px solid black`,
                          fontSize: "24px",
                          padding: "6px",
                          height: "22px",
                          textAlign: "center",
                        }}
                      >
                        {/* Show individual discount amount for each item */}
                        {isPrint
                          ? Math.round(
                              discountPerQuantity[rowIndex] *
                                row?.quantity_return
                            )?.toLocaleString("en-IN")
                          : Math.round(
                              discountAmtPrnt[rowIndex]
                            )?.toLocaleString("en-IN")}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: `1px solid black`,
                          fontSize: "24px",
                          padding: "6px",
                          height: "22px",
                          textAlign: "center",
                        }}
                      >
                        {/* Discounted price */}
                        {isPrint
                          ? (
                              row?.sell_price * row?.quantity_return -
                              row?.sell_price *
                                row?.quantity_return *
                                (row?.discount_percentage / 100)
                            )?.toLocaleString("en-IN")
                          : Math.round(
                              totalDiscountedAmtPrnt[rowIndex]
                            )?.toLocaleString("en-IN")}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ) : null
            )}
            <TableRow>
              <TableCell
                sx={{ fontWeight: 500, padding: "6px", fontSize: "24px" }}
                colSpan={hasDiscountPercentagePrevious ? 3 : 2}
              >
                Total Items:{" "}
                {isPrint ? uniqueMedicineCount : uniqueMedicineCount}
              </TableCell>

              {/* <TableCell
                sx={{ fontWeight: 500, padding: "6px", fontSize: "24px" }}
              >
                {isPrint
                  ? totalReturnMedicineAmtPrint
                  : totalReturnMedicineAmt?.toLocaleString("en-IN")}
              </TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReturnInvoiceTable;
